export const FETCH_GRATUITY_MASTER_DDL = "FETCH_GRATUITY_MASTER_DDL";
export const CREATE_GRATUITY_MASTER = "CREATE_GRATUITY_MASTER";
export const EDIT_GRATUITY_MASTER = "EDIT_GRATUITY_MASTER";
export const DELETE_GRATUITY_MASTER = "DELETE_GRATUITY_MASTER";
